export default "__VITE_ASSET__CJwpDboG__"